module.exports = __webpack_public_path__ + "img/img-5.31ee0af3.webp";